import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import styled from 'styled-components';

import { TwoColumn, TwoColumnContent } from 'components/layouts/two-column';
import { OneColumn, OneColumnContent } from 'components/layouts/one-column';

import { Header } from 'src/dispensary/core-menu/components/header';
import StoreInfo from 'src/dispensary/components/store-info';
import MetaTags from 'components/meta-tags';
import { DutchiePrivacyFooter } from 'src/dispensary/core-menu/components/dutchie-privacy-footer';
import Wrapper from 'components/wrapper';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { MainContent } from 'components/skip-to-main';

export default function CoreMenuInfoPage() {
  const { dispensary } = useDispensary();
  const isDesktopMenuSize = useMediaQuery((theme) => theme.breakpoints.up(`md`));
  const ColumnLayout = isDesktopMenuSize ? OneColumn : TwoColumn;
  const ContentLayout = isDesktopMenuSize ? OneColumnContent : TwoColumnContent;

  if (!dispensary) {
    return null;
  }

  return (
    <Wrapper>
      <MetaTags />
      <Header dispensary={dispensary} />
      <ColumnLayout>
        <Container>
          <ContentLayout>
            <StyledMainContent>
              <StoreInfo dispensary={dispensary} />
            </StyledMainContent>
          </ContentLayout>
        </Container>
      </ColumnLayout>
      <DutchiePrivacyFooter />
    </Wrapper>
  );
}

const Container = styled.div`
  width: 100%;
`;

const StyledMainContent = styled(MainContent)`
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    padding: unset;
  }
`;
